import { graphql } from '@/generated/gql';

export const UPDATE_SMART_LINK_MUTATION = graphql(/* GraphQL */ `
  mutation UpdateSmartLink($data: [AstroSmartLinkInput!]!) {
    astronaut {
      smartLink {
        upsert(data: $data) {
          id
        }
      }
    }
  }
`);
